import { copyFinder, finderChanges } from '../../models/legacyFinderDraft';

export default {
  props: { finderValue: { type: Object, required: true } },
  data: () => ({ sectionBaseline: {} }),
  methods: {
    emitFinderChanges() {
      this.$emit('updateLastSearch', finderChanges(this.sectionBaseline, this.finder));
      this.sectionBaseline = copyFinder(this.finder);
    }
  }
};
